<div class="relative inline-flex" (click)="$event.stopPropagation()">
    <button type="button" class="inline-flex items-center justify-center w-11 h-11 text-2xl rounded-full hover:bg-gray-100 text-secondary" (click)="toggle($event)">
        <vlp-icon [icon]="'heroicons_outline:user-circle'"></vlp-icon>
    </button>

    <div *ngIf="open" class="absolute right-0 top-11 z-[1100] min-w-56 py-2 rounded-lg bg-card shadow-lg border border-gray-200">
        <div class="px-4 py-2">
            <span class="flex flex-col leading-none">
                <span class="text-secondary text-sm">{{ "user.signed-in-as" | transloco }}</span>
                <span class="mt-1.5 text-md font-medium">{{ account.Username }}</span>
            </span>
        </div>
        <hr class="my-2 border-gray-200" />
        <button type="button" class="flex items-center gap-2 w-full px-4 py-2 text-left hover:bg-gray-100" (click)="showProfile()">
            <vlp-icon [icon]="'heroicons_outline:user-circle'"></vlp-icon>
            <span>{{ "user.profile" | transloco }}</span>
        </button>
        <hr class="my-2 border-gray-200" />
        <button type="button" class="flex items-center gap-2 w-full px-4 py-2 text-left hover:bg-gray-100" (click)="signOut()">
            <vlp-icon [icon]="'heroicons_outline:arrow-right-on-rectangle'"></vlp-icon>
            <span>{{ "user.sign-out" | transloco }}</span>
        </button>
    </div>
</div>
